import React, { SVGProps } from 'react'
const SvgHide = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
      <path d="m5.406 9.466 1.06 1.06c-.956.782-1.917 1.765-2.886 2.949a.75.75 0 1 1-1.16-.95c.99-1.21 1.985-2.229 2.986-3.059Zm1.211-.91c.391-.263.783-.498 1.175-.704l1.113 1.114c-.403.186-.807.408-1.212.667L6.617 8.556Zm2.656-1.344c4.118-1.397 8.266.374 12.307 5.313a.75.75 0 1 1-1.16.95c-3.368-4.116-6.644-5.8-9.937-5.053l-1.21-1.21Z" />
      <path d="m13.517 17.578 1.21 1.21c-4.118 1.397-8.266-.374-12.307-5.313a.75.75 0 1 1 1.16-.95c3.368 4.116 6.644 5.8 9.937 5.053Zm1.578-.544c.403-.186.807-.408 1.212-.667l1.076 1.077c-.391.263-.783.498-1.175.704l-1.113-1.114Zm2.439-1.56c.956-.782 1.917-1.765 2.886-2.949a.75.75 0 0 1 1.16.95c-.99 1.21-1.985 2.23-2.986 3.059l-1.06-1.06Z" />
      <path d="M12.636 16.696a3.75 3.75 0 0 1-4.332-4.332l1.73 1.73c.203.366.506.669.872.873l1.73 1.73Zm1.504-.616-1.09-1.09c.4-.211.729-.54.94-.94l1.09 1.09a3.771 3.771 0 0 1-.94.94Zm1.556-2.444-1.73-1.73a2.26 2.26 0 0 0-.872-.873l-1.73-1.73a3.75 3.75 0 0 1 4.332 4.332ZM9.86 9.92l1.09 1.09c-.4.211-.729.54-.94.94l-1.09-1.09c.255-.366.574-.685.94-.94Z" />
      <path d="M19.032 18.972 5.497 5.436a.75.75 0 0 0-1.06 1.06l13.535 13.536a.75.75 0 0 0 1.06-1.06Z" />
    </g>
  </svg>
)
export default SvgHide
